import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { resolveProviderName } from './index';

// Auth0 needs its React context mounted to complete the redirect callback;
// Firebase does not (the SDK handles its own redirect result). So the wrapper
// is mounted only for the provider that needs it, and its config comes from
// env rather than being hardcoded inline as it was before AI4-407.
const AuthProviderGate = ({ children }) => {
    if (resolveProviderName() !== 'auth0') return <>{children}</>;

    const domain = process.env.REACT_APP_AUTH0_DOMAIN;
    const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

    if (!domain || !clientId) {
        // Loud in the console rather than a blank screen: without these the
        // Auth0 redirect silently never completes.
        // eslint-disable-next-line no-console
        console.error('[auth] REACT_APP_AUTH0_DOMAIN / REACT_APP_AUTH0_CLIENT_ID are not set.');
    }

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            redirectUri={`${window.location.origin}`}>
            {children}
        </Auth0Provider>
    );
};

export default AuthProviderGate;
